import React, { useState, useEffect, useRef, useCallback } from "react";

import { Form } from "@unform/web";
import {
  FormGroup,
  Row,
  Col,
  Container,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { FaTrashAlt, FaCheck } from "react-icons/fa";

import {
  Checkbox,
  DefaultSelect,
  DefaultInput,
  ToggleButton,
  Button,
} from "ui-kit-takeat";

import NotificationAlert from "react-notification-alert";

import Input from "../../components/Input";
import Select from "../../components/Form/SelectInput";
import Avatar from "./Avatar";

import { Card, CheckBoxArea } from "./styles";

import { useRestaurants } from "context/RestaurantsContext";

import history from "../../../services/history";
import apiGd from "../../../services/apiGd";

export default function EditMultistores(props) {
  const { getMultistores } = useRestaurants();

  const { id } = props.match.params;

  const notificationAlert = useRef(null);
  const notify = (place, color, message) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: color,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7,
    };
    notificationAlert.current.notificationAlert(options);
  };

  const [users, setUsers] = useState([]);
  const [multistore, setMultistore] = useState({});
  const [responsibleUser, setResponsibleUser] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [childStoreId, setChildStoreId] = useState(null);
  const [newPassword, setNewPassword] = useState("");

  const [modalPassword, setModalPassword] = useState(false);
  function toggleModalPassword() {
    setNewPassword("");
    setModalPassword(!modalPassword);
  }

  const formRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState('');
  const [availableRestaurants, setAvailableRestaurants] = useState([]);

  const [children, setChildren] = useState([]);

  const getMultistoreById = useCallback(async () => {
    const token = localStorage.getItem("@QRExpress:tokenGd");
    const reqConfig = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await apiGd.get(`admin/multistores/${id}`, reqConfig);

      const multistoreData = {
        fantasy_name: data.fantasy_name,
        name: data.name,
        email: data.email,
        password: null,
        avatar_id: data.avatar?.id || null,

        controls_cost_center: data.multistore_settings.controls_cost_center,
        controls_stock: data.multistore_settings.controls_stock,
        controls_menu: data.multistore_settings.controls_menu,
        responsible_user_id: data.responsible_user?.id || null,
      };

      formRef.current.setData(multistoreData);

      setMultistore(multistoreData);
      setChildren(data.children);
      setAvatar(data.avatar);

      if (data.responsible_user) {
        const { id: userId, name: userName } = data.responsible_user;
        setResponsibleUser({ label: userName, value: userId });
      } else {
        setResponsibleUser(null);
      }
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
      console.log(err);
    }
  }, [id]);

  const getUsers = useCallback(async () => {
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");

      const res = await apiGd.get("/restaurants/users", {
        headers: {
          Authorization: `Bearer: ${token}`,
        },
      });

      // Removendo o usuario Admin/Padrao do nosso dash
      const users = res.data
        .filter((data) => data.id !== 1)
        .map((data) => {
          return {
            label: data.name,
            value: data.id,
          };
        });

      setUsers(users);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
    }
  }, []);

  const getAvailableRestaurants = useCallback(async () => {
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");

      const res = await apiGd.get("/admin/multistores/available-restaurants", {
        headers: {
          Authorization: `Bearer: ${token}`,
        },
      });

      // Removendo o usuario Admin/Padrao do nosso dash
      const restaurants = res.data
        .map((data) => {
          return {
            label: data.fantasy_name,
            value: data.id,
            name: data.name,
          };
        });

      setAvailableRestaurants(restaurants);
    } catch (err) {
      notify("tr", "danger", "Erro ao carregar informações.");
    }
  }, []);

  useEffect(() => {
    getMultistoreById();
    getUsers();
    getAvailableRestaurants();
  }, []);

  function handleSetAvatar(fn) {
    const { avatar_id } = fn({});

    setAvatar({ id: avatar_id });
  }

  async function handleSubmit(data) {
    const restaurantData = {
      ...data,
      responsible_user_id: responsibleUser?.value || null,
    };

    if (avatar) {
      restaurantData.avatar_id = avatar.id;
    }

    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const response = await apiGd.put(
        `admin/restaurants/${id}`,
        restaurantData,
        reqConfig
      );
      getMultistores();
    } catch (err) {
      notify("tr", "danger", "Erro ao salvar.");
    }
  }

  async function handleAddChild() {
    setLoading(true);
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      console.log('@@', childStoreId)
      setLoadingMsg('Adicionando loja filha');

      const has_cloning =
        multistore?.controls_menu ||
        multistore?.controls_stock ||
        multistore?.controls_cost_center;

      if (has_cloning) {
        await apiGd.post(
          `/admin/restaurants/multistores/clone-menu`,
          {
            restaurant_id1: id,
            restaurant_id2: childStoreId,
          },
          reqConfig
        );
      } else {
        await apiGd.post(
          "/admin/multistores/add-child-store",
          {
            multistore_id: id,
            restaurant_id: childStoreId,
          },
          reqConfig
        );
      }

      const restaurant = availableRestaurants.find((r) => r.value === childStoreId);
      if (restaurant) {
        const child = {
          id: restaurant.value,
          name: restaurant.name,
          fantasy_name: restaurant.label,
        };
        setChildren((prev) => [...prev, child]);
      }

      getMultistores();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      notify("tr", "danger", "Erro ao salvar.");
    }
  }

  async function handleRemoveChild(child_id) {
    setLoading(true);
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");
      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      setLoadingMsg('Removendo loja filha');

      await apiGd.post(
        `admin/multistores/remove-child-store`,
        {
          multistore_id: id,
          restaurant_id: child_id,
        },
        reqConfig
      );

      setChildren((s) => s.filter((r) => r.id !== child_id));
      getMultistores();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      notify("tr", "danger", "Erro ao salvar.");
    }
  }

  const updatePassword = useCallback(async () => {
    try {
      const token = localStorage.getItem("@QRExpress:tokenGd");

      const reqConfig = {
        headers: { Authorization: `Bearer ${token}` },
      };

      if (newPassword.length < 6) {
        notify("tr", "danger", "Senha tem que ter no mínimo 6 caracteres");
      } else {
        await apiGd.put(
          `admin/restaurants/password/${id}`,
          { password: newPassword },
          reqConfig
        );

        toggleModalPassword();

        notify("tr", "success", "Senha atualizada com sucesso!");
      }
    } catch (err) {
      notify("tr", "danger", "Erro ao atualizar senha");
    }
  }, [newPassword, id]);

  return (
    <>
      <NotificationAlert ref={notificationAlert} />
      <div className="content">
        <Row style={{ flexDirection: "row", justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              onClick={() => history.goBack()}
              title="Voltar"
              buttonColor="#333333"
              style={{ width: 100, marginRight: '20px' }}
            />
            <h3> Editar Multilojas </h3>
          </div>

          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Button
              onClick={toggleModalPassword}
              title="Alterar senha"
              buttonColor="#FFB32F"
              style={{ width: 100, marginRight: '5px' }}
            />
            <Button
              onClick={() => history.goBack()}
              title="Deletar"
              buttonColor="#C8131B"
              style={{ width: 100 }}
            />
          </div>

        </Row>
        <Row>
          <Form
            initialData={{}}
            className="form-horizontal"
            style={{ width: '100%' }}
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Card>
              <Col md="12">
                <Row style={{ marginTop: 10 }}>
                  <Col md="8">
                    <Row style={{ flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Nome</span>
                      <Input
                        type="text"
                        name="fantasy_name"
                        title="Nome de exibição"
                      />
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Nome de usuário</span>
                      <Input
                        title="Nome de usuário"
                        type="text"
                        name="name"
                      />
                      <span>
                        Esse nome é um identificador único do estabelecimento, deve
                        ter letras minúsculas e sem espaço. Ex: 'mcdonalds' / 'bobs'
                        / 'burgerking'
                      </span>
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <span style={{ fontWeight: "bold" }}>Email</span>
                      <Input
                        type="email"
                        name="email"
                        title="Email"
                        autocomplete="new-password"
                      />
                    </Row>
                    <Row style={{ marginTop: 10, flexDirection: "column" }}>
                      <Select
                        label="Vendedor responsável"
                        name="responsible_user_id"
                        options={users}
                        value={responsibleUser}
                        onChange={(e) => {
                          const user = users.find((u) => u.value === e.value);
                          setResponsibleUser(user);
                        }}
                      />
                    </Row>
                  </Col>
                  <Col md="4">
                    <Row
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Col>
                          <Avatar
                            ref={formRef}
                            name="avatar"
                            setRestaurantData={handleSetAvatar}
                            value={avatar}
                          />

                          <CheckBoxArea>
                            <p> Controle </p>

                            <Checkbox
                              label="Controle de cardápio"
                              name="controls_menu"
                              containerStyles={{ cursor: 'not-allowed' }}
                              checked={multistore?.controls_menu}
                            />

                            <Checkbox
                              label="Controle de estoque"
                              name="controls_stock"
                              containerStyles={{ cursor: 'not-allowed' }}
                              checked={multistore?.controls_stock}
                            />

                            <Checkbox
                              label="Controle de Centro de Custo"
                              name="controls_cost_center"
                              containerStyles={{ cursor: 'not-allowed' }}
                              checked={multistore?.controls_cost_center}
                            />
                          </CheckBoxArea>
                          <div style={{ display: 'flex', alignItems: 'end', gap: 12 }}>
                            <DefaultSelect
                              label="Loja filhas"
                              name="child_store_id"
                              options={availableRestaurants}
                              onChange={(e) => setChildStoreId(e.value)}
                            />
                            <FaCheck
                              color="white"
                              style={{
                                cursor: 'pointer',
                                backgroundColor: '#2ec9b7',
                                padding: 10,
                                borderRadius: 4,
                                width: 44,
                                height: 38,
                              }}
                              onClick={handleAddChild}
                            />
                          </div>

                          {children
                            .map((child) => (
                              <div
                                key={child.id}
                                style={{
                                  display: 'flex',
                                  itemsAlign: 'center',
                                  gap: '12px',
                                  marginTop: '3px',
                                  fontSize: 14,
                                }}
                              >
                                <span style={{
                                  fontWeight: 500,
                                  width: '100%',
                                  alignContent: 'center',
                                }}>
                                  {child.fantasy_name}
                                </span>

                                <FaTrashAlt
                                  color="#C8131B"
                                  style={{
                                    cursor: 'pointer',
                                    padding: 8,
                                    width: 55,
                                    height: 32,
                                  }}
                                  onClick={() => handleRemoveChild(child.id)}
                                />
                              </div>
                            ))
                          }
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row style={{ marginTop: 50 }}>
                  <Col md="12" style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button
                      color="success"
                      type="submit"
                      title="Salvar"
                      buttonColor="#2ec9b7"
                    />
                  </Col>
                </Row>
              </Col>
            </Card>
          </Form>
        </Row>
      </div>
     
      <Modal isOpen={modalPassword} toggle={toggleModalPassword}>
        <ModalHeader> Alterar senha </ModalHeader>
        <ModalBody>
          <Form>
            <Container>
              <Row>
                <Col md="12">
                  <label> Nova Senha </label>
                  <Input
                    name="password"
                    type="text"
                    placeholder="Mínimo 6 caracteres"
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </Col>
              </Row>
            </Container>
          </Form>
        </ModalBody>
        <ModalFooter style={{ padding: '6px' }}>
          <Button title="Confirmar" buttonColor="#2ec9b7" onClick={updatePassword} />
          <Button title="Cancelar" buttonColor="#C8131B" onClick={toggleModalPassword} />
        </ModalFooter>
      </Modal>

      <Modal isOpen={loading}>
        <ModalHeader> Aguarde </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
           <Spinner color="danger" />
            <div style={{ marginLeft: 10 }}> {loadingMsg} </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

